module.exports = __webpack_public_path__ + "static/media/SnackCrunch.fd68403b.mp3";